/* eslint-disable no-debugger */
import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const getUsasClub = (usasClubId, state, setState) => {
    if (usasClubId.length > 0) {
        const api = initApi(API_NAMES.CLUB, state, setState);
        const usasClubIdForUrl = encodeURIComponent(usasClubId);
        const url = `/UsasClub/${usasClubIdForUrl}/usasClubRegistration`;
        return api?.executeObject ? api.executeObject(url, 'GET') : null;
    }
}

const postNewClubRegistrationData = (clubObj, state, setState) => {
    if (clubObj) {
        const api = initApi(API_NAMES.CLUB, state, setState);
        const url = `/UsasClub/ClubRegistration`;

        return api?.executeObject ? api.executeObject(url, 'POST', clubObj) : null;
    }
};

const putNewClubRegistrationData = (usasClubId, clubObj, state, setState) => {
    if (usasClubId.length > 0 && clubObj) {
    //   let newState = {
    //     ...state,
    //     isSaving: true
    //   };
  
      //const api = initApi(API_NAMES.CLUB, newState, setState);
      const api = initApi(API_NAMES.CLUB, state, setState);
      const usasClubIdForUrl = encodeURIComponent(usasClubId);
      const url = `/UsasClub/${usasClubIdForUrl}/usasClubRegistration`;
      return api?.executeObject ? api.executeObject(url, 'PUT', clubObj) : null;
    }
  };

const NewClubRegistrationData = { 
    getUsasClub,
    postNewClubRegistrationData,
    putNewClubRegistrationData 
};

export default NewClubRegistrationData;